// Centralized start-point endpoints used by create/update/delete/list operations.
const startPointsEndpoints = {
  // Collection endpoint.
  base: '/v1/cms/start-points',
  // Single entity endpoint.
  byId: (id) => `/v1/cms/start-points/${id}`
};

export default startPointsEndpoints;
